module.exports = __webpack_public_path__ + "img/0Q3A3375_L_WoodMatted.c070b865.jpg";